import { render, staticRenderFns } from "./TextAndImage.vue?vue&type=template&id=9c9f75b2"
import script from "./TextAndImage.vue?vue&type=script&lang=js"
export * from "./TextAndImage.vue?vue&type=script&lang=js"
import style0 from "./TextAndImage.vue?vue&type=style&index=0&id=9c9f75b2&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports